import { createAction, createApiAction, createErrorAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { TM_DEFAULT_TEAM_NAME } from '@saucelabs/sl-util-config';

import * as types from './types';
import * as api from './api';
import { types as teamsTypes } from './../../ducks/teams';
import { api as usersApi } from './../../ducks/users';

export const getInitialTeamDetailsRequest = createAction(types.INITIAL_DATA.REQUEST);
export const getInitialTeamDetailsSuccess = createAction(types.INITIAL_DATA.SUCCESS);
export const getInitialTeamDetailsFailure = createErrorAction(types.INITIAL_DATA.FAILURE);
export const movedSelectedUsersToTeam = createErrorAction(types.MOVED_SELECTED_USERS_TO_TEAM);
export const cleanup = createAction(types.CLEANUP);
export const updateFilter = createAction(types.TOGGLE_FILTER);
export const clearFilters = createAction(types.CLEAR_FILTERS);
export const toggleDefaultTeamUser = createAction(types.TOGGLE_DEFAULT_TEAM_USER);

export const getTeam = createApiAction(
  types.TEAM_GET,
  (payload) => api.getTeam(payload),
);

export const patchTeam = createApiAction(
  teamsTypes.TEAM_PATCH,
  (payload) => api.patchTeam(payload),
);

export const getTeamUsersUsageCSV = createApiAction(
  types.GET_TEAM_USERS_USAGE_CSV,
  (payload, meta, dispatch) => (
    api.getTeamUsersUsageCSV(payload)
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);

export const getDefaultTeamUsers = createApiAction(types.DEFAULT_TEAM_USERS_GET, (payload) => (
  usersApi.getUsers({ team_name: TM_DEFAULT_TEAM_NAME, ...payload })
));
